export default "__VITE_ASSET__VRl4i8oY__"